/** Shared `{ value, label }` enum entry shape served by the API, as it comes off the wire. */
export type AiTranscriptionDeliveryModePayload = {
	readonly value: string;
	readonly label: string;
};

export type AiTranscriptionDeliveryModesFetchedPayload = AiTranscriptionDeliveryModePayload[];

export type AiTranscriptionDeliveryModesFetchedAction = {
	type: 'AI_TRANSCRIPTION_DELIVERY_MODES_FETCHED';
	payload: AiTranscriptionDeliveryModesFetchedPayload;
};

export default (
	payload: AiTranscriptionDeliveryModesFetchedPayload,
): AiTranscriptionDeliveryModesFetchedAction => ({
	type: 'AI_TRANSCRIPTION_DELIVERY_MODES_FETCHED',
	payload,
});
